"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslitService = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const Matcher_1 = require("./Matcher");
const schemes_1 = require("./schemes");
/**
 * Headless translit service. Owns:
 *
 * - the registry of available schemes
 * - the active scheme id (`null` = mode off)
 * - a cache of compiled schemes
 */
class TranslitService {
    constructor(schemes = schemes_1.defaultSchemes) {
        /** Active scheme id, or null when mode is off. */
        this.active = ui_1.rsync.val(null);
        /** Last-used scheme id (so a no-arg toggle can restore the last selection). */
        this.lastUsed = ui_1.rsync.val(null);
        this._compiled = new Map();
        this.schemes = (0, schemes_1.schemeMap)(schemes);
    }
    /** Lazy-compile and cache. */
    compile(scheme) {
        const cached = this._compiled.get(scheme.id);
        if (cached)
            return cached;
        const c = new Matcher_1.CompiledScheme(scheme);
        this._compiled.set(scheme.id, c);
        return c;
    }
    /** The currently active compiled scheme, or null. */
    activeScheme() {
        const id = this.active.value;
        if (!id)
            return null;
        const scheme = this.schemes.get(id);
        if (!scheme)
            return null;
        return this.compile(scheme);
    }
    list() {
        return Array.from(this.schemes.values());
    }
    /** Switch on with a specific scheme. */
    on(id) {
        if (!this.schemes.has(id))
            return false;
        this.lastUsed.set(id);
        this.active.set(id);
        return true;
    }
    /** Switch off. */
    off() {
        this.active.set(null);
    }
    /** Toggle the mode. With no arg: flip current state, restoring `lastUsed`
     * if turning on. With an id: switch to that scheme. */
    toggle(id) {
        if (id) {
            if (this.active.value === id) {
                this.off();
                return;
            }
            this.on(id);
            return;
        }
        if (this.active.value) {
            this.off();
            return;
        }
        const restore = this.lastUsed.value ?? this.list()[0]?.id;
        if (restore)
            this.on(restore);
    }
    /** Add a custom scheme to the registry. */
    register(scheme) {
        this.schemes.set(scheme.id, scheme);
        this._compiled.delete(scheme.id);
    }
}
exports.TranslitService = TranslitService;
